import { render, staticRenderFns } from "./MobileCheckout.vue?vue&type=template&id=faba4c0c&scoped=true&"
import script from "./MobileCheckout.vue?vue&type=script&lang=js&"
export * from "./MobileCheckout.vue?vue&type=script&lang=js&"
import style0 from "./MobileCheckout.vue?vue&type=style&index=0&id=faba4c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faba4c0c",
  null
  
)

export default component.exports